import { createSlice } from "@reduxjs/toolkit";
import { InitialLabourCostFormData } from "../../ConstantData/InitialData";

const labourCostSlice = createSlice({
  name: "labourcost",
  initialState: {
    labourCostList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    initialData: InitialLabourCostFormData,
  },
  reducers: {
    getAllLabourCost: (state, action) => {
      state.labourCostList = action.payload;
    },
    getLabourCost: () => {},
    getLabourCostDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialLabourCostFormData };
    },
    updateLabourCost: (state, action) => {},
    deleteLabourCost: () => {},
  },
});

export const labourCostSliceAction = labourCostSlice.actions;

export default labourCostSlice.reducer;
